import { Component, Output, EventEmitter, Input  } from '@angular/core';

@Component({
  selector: 'app-q1-feedback-enough-correct-page',
  templateUrl: './q1-feedback-enough-correct-page.component.html',
  styleUrls: ['./q1-feedback-enough-correct-page.component.scss']
})
export class Q1FeedbackEnoughCorrectPageComponent {
  @Input() correctSelections: number;
  @Input() incorrectShops: {id: string, feedback: string}[];
  @Output() continueClick = new EventEmitter<void>();
  @Output() navigateToSlider = new EventEmitter<string>();
  
  onNavigateToSlider(shopId: string) {
    this.navigateToSlider.emit(shopId);
  }

  onContinueClick(): void {
    this.continueClick.emit();
  }
}
